'use strict';
import axios from 'axios';
import { notification } from 'ant-design-vue';

export const post = (url,data) => {
    return new Promise((resolve, reject)=>{
        axios.post(url,data)
            .then((res)=>{
                if(res.data && !res.data.success){
                    notification.error({
                        message: '加载失败',
                        description: res.data.msg,
                    });
                    reject(res);
                }else{
                    resolve(res.data);
                }

            })
            .catch((err)=>{
                notification.error({
                    message: '加载失败',
                    description: '请稍后尝试重新加载!',
                });
                reject(err);

            });
    });
};
export const files = (url,data) => {
    return new Promise((resolve, reject)=>{
        axios({
            url:url,
            method:'get',
            responseType:'blob',
            ...data
        })
            .then((res)=>{
               
                if(res.data && !res.success && res.status != 200){
                    data && !data.noTips && notification.error({
                        message: '加载失败',
                        description: res.data.msg,
                    });
                    reject(res);

                }else{
                    resolve(res.data);

                }

            })
            .catch((err)=>{
                data && !data.noTips && notification.error({
                    message: '加载失败',
                    description: '请稍后尝试重新加载!',
                });
                reject(err);

            });
    });
};
